<template>
  <div id="operaciones-csv">
    <div class="row">
      <div class="col-12">
        <h2 class="generalTitle">Operaciones CSV</h2>
      </div>
    </div>

    <div class="row mx-1 mt-3">
      <!-- Card 1: DESCARGAR CONTRATOS FIRMADOS EN TECALIS -->
      <div class="col-12 col-md-3 mb-4">
        <div class="card operation-card h-100">
          <div class="card-body d-flex flex-column">
            <div class="operation-icon mb-3">
              <v-icon name="bi-download" scale="2" />
            </div>
            <h5 class="card-title">Descargar Contratos Firmados en Tecalis</h5>
            <p class="card-text text-muted flex-grow-1">
              Adjunte un CSV con los contratos a descargar y recibirá la información en el email indicado.
            </p>
            <a href="/templates/plantilla_descarga_contratos_tecalis.csv" download class="btn btn-outline-secondary btn-sm mb-2">
              <v-icon name="bi-filetype-csv" scale="0.8" class="mr-1" />
              Descargar plantilla
            </a>
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#downloadContractsModal"
            >
              <v-icon name="bi-download" scale="0.9" class="mr-1" />
              DESCARGAR CONTRATOS FIRMADOS EN TECALIS
            </button>
          </div>
        </div>
      </div>

      <!-- Card 2: ENVÍO BUROFAX 2 -->
      <div class="col-12 col-md-3 mb-4">
        <div class="card operation-card h-100">
          <div class="card-body d-flex flex-column">
            <div class="operation-icon mb-3">
              <v-icon name="bi-upload" scale="2" />
            </div>
            <h5 class="card-title">Envío Burofax 2</h5>
            <p class="card-text text-muted flex-grow-1">
              Adjunte un CSV con los datos de reclamaciones impagadas para iniciar el envío de Burofax.
            </p>
            <a href="/templates/plantilla_envio_burofax_2.csv" download class="btn btn-outline-secondary btn-sm mb-2">
              <v-icon name="bi-filetype-csv" scale="0.8" class="mr-1" />
              Descargar plantilla
            </a>
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#uploadBurofaxModal"
            >
              <v-icon name="bi-upload" scale="0.9" class="mr-1" />
              ENVÍO BUROFAX 2
            </button>
          </div>
        </div>
      </div>

      <!-- Card 3: DESCARGA DOCUMENTOS BUROFAX -->
      <div class="col-12 col-md-3 mb-4">
        <div class="card operation-card h-100">
          <div class="card-body d-flex flex-column">
            <div class="operation-icon mb-3">
              <v-icon name="bi-file-earmark-text" scale="2" />
            </div>
            <h5 class="card-title">Descarga Documentos Burofax</h5>
            <p class="card-text text-muted flex-grow-1">
              Adjunte un CSV con los números de contrato para recibir la documentación por email.
            </p>
            <a href="/templates/plantilla_descarga_documentos_burofax.csv" download class="btn btn-outline-secondary btn-sm mb-2">
              <v-icon name="bi-filetype-csv" scale="0.8" class="mr-1" />
              Descargar plantilla
            </a>
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#downloadDocsBurofaxModal"
            >
              <v-icon name="bi-download" scale="0.9" class="mr-1" />
              DESCARGA DOCUMENTOS BUROFAX
            </button>
          </div>
        </div>
      </div>

      <!-- Card 4: CARGAR TRANSFERENCIAS WALLET MGM -->
      <div class="col-12 col-md-3 mb-4">
        <div class="card operation-card h-100">
          <div class="card-body d-flex flex-column">
            <div class="operation-icon mb-3">
              <v-icon name="bi-wallet2" scale="2" />
            </div>
            <h5 class="card-title">Transferencias Wallet MGM</h5>
            <p class="card-text text-muted flex-grow-1">
              Adjunte un CSV con las transferencias bancarias realizadas a los clientes de su dinero wallet de MGM.
            </p>
            <a href="/templates/plantilla_transferencias_wallet_mgm.csv" download class="btn btn-outline-secondary btn-sm mb-2">
              <v-icon name="bi-filetype-csv" scale="0.8" class="mr-1" />
              Descargar plantilla
            </a>
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#uploadWalletCSVModal"
            >
              <v-icon name="bi-upload" scale="0.9" class="mr-1" />
              CARGAR TRANSFERENCIAS
            </button>
          </div>
        </div>
      </div>

      <!-- Card 5: REENVÍO DE FACTURAS -->
      <div class="col-12 col-md-3 mb-4">
        <div class="card operation-card h-100">
          <div class="card-body d-flex flex-column">
            <div class="operation-icon mb-3">
              <v-icon name="bi-receipt" scale="2" />
            </div>
            <h5 class="card-title">Reenvío de Facturas</h5>
            <p class="card-text text-muted flex-grow-1">
              Adjunte un CSV con los contratos y cuotas para reenviar las facturas a los clientes.
            </p>
            <a href="/templates/plantilla_reenvio_facturas.csv" download class="btn btn-outline-secondary btn-sm mb-2">
              <v-icon name="bi-filetype-csv" scale="0.8" class="mr-1" />
              Descargar plantilla
            </a>
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#uploadInvoiceCSVModal"
            >
              <v-icon name="bi-upload" scale="0.9" class="mr-1" />
              REENVÍO DE FACTURAS
            </button>
          </div>
        </div>
      </div>
    </div>

    <ModalDownloadContracts
      ref="downloadContractsModal"
      :id="'downloadContractsModal'"
      :modalTitle="'DESCARGAR CONTRATOS FIRMADOS EN TECALIS'"
      @submitForm="handleDownloadContracts"
    />

    <ModalUploadBurofaxCSV
      ref="uploadBurofaxModal"
      :id="'uploadBurofaxModal'"
      :modalTitle="'ENVÍO BUROFAX 2'"
      @submitForm="handleUploadBurofax"
    />

    <ModalDownloadDocsBurofax
      ref="downloadDocsBurofaxModal"
      :id="'downloadDocsBurofaxModal'"
      :modalTitle="'DESCARGA DOCUMENTOS BUROFAX'"
      @submitForm="handleDownloadDocsBurofax"
    />

    <ModalUploadWalletCSV
      ref="uploadWalletCSVModal"
      :id="'uploadWalletCSVModal'"
      :modalTitle="'CARGAR TRANSFERENCIAS WALLET MGM'"
      @submitForm="handleUploadWalletCSV"
    />

    <ModalUploadInvoiceCSV
      ref="uploadInvoiceCSVModal"
      :id="'uploadInvoiceCSVModal'"
      :modalTitle="'REENVÍO DE FACTURAS'"
      @submitForm="handleUploadInvoiceCSV"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ModalDownloadContracts from "@/components/Widgets/Contracts/ContractsList/templates/ModalDownloadContracts.vue";
import ModalUploadBurofaxCSV from "@/components/Widgets/Contracts/ContractsList/templates/ModalUploadBurofaxCSV.vue";
import ModalDownloadDocsBurofax from "@/components/Widgets/Contracts/ContractsList/templates/ModalDownloadDocsBurofax.vue";
import ModalUploadWalletCSV from "./templates/ModalUploadWalletCSV.vue";
import ModalUploadInvoiceCSV from "./templates/ModalUploadInvoiceCSV.vue";

export default {
  name: "OperacionesCSVDashboard",
  components: {
    ModalDownloadContracts,
    ModalUploadBurofaxCSV,
    ModalDownloadDocsBurofax,
    ModalUploadWalletCSV,
    ModalUploadInvoiceCSV,
  },
  methods: {
    handleDownloadContracts({ email, formData }) {
      const token = this.$cookies.get('token');
      const apiUrl = `/contract/contracts-csv/${email}`;
      axios.patch(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          const modal = this.$refs.downloadContractsModal;
          modal.successMessage = 'Contratos recuperados exitosamente.';
          modal.loading = false;
          setTimeout(() => {
            modal.closeModal();
          }, 5000);
        })
        .catch(() => {
          const modal = this.$refs.downloadContractsModal;
          modal.errorMessage = 'Ocurrió un error al recuperar los contratos. Por favor, inténtalo de nuevo.';
          modal.loading = false;
          setTimeout(() => {
            modal.resetForm();
          }, 5000);
        });
    },

    handleUploadBurofax({ formData, emailReceiver }) {
      const token = this.$cookies.get('token');
      const apiUrl = `/contract/unpaid-claim-csv/${encodeURIComponent(emailReceiver)}`;

      axios.patch(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          const modal = this.$refs.uploadBurofaxModal;
          modal.successMessage = 'El archivo CSV se ha procesado exitosamente. Se ha iniciado el envío de Burofax.';
          modal.loading = false;
          setTimeout(() => {
            modal.closeModal();
          }, 5000);
        })
        .catch((error) => {
          const modal = this.$refs.uploadBurofaxModal;
          let errorMsg = 'Ocurrió un error al procesar el archivo CSV. Por favor, inténtalo de nuevo.';

          if (error.response) {
            if (error.response.status === 400) {
              errorMsg = 'El archivo CSV tiene un formato inválido. Por favor, verifica el contenido.';
            } else if (error.response.status === 401 || error.response.status === 403) {
              errorMsg = 'No tienes permisos para realizar esta operación.';
            } else if (error.response.data && error.response.data.message) {
              errorMsg = error.response.data.message;
            }
          }

          modal.errorMessage = errorMsg;
          modal.loading = false;
          setTimeout(() => {
            modal.resetForm();
          }, 5000);
        });
    },

    handleDownloadDocsBurofax({ emailReceiver, formData }) {
      const token = this.$cookies.get('token');
      const apiUrl = `/contract/send-documents-unpaid-claim/${encodeURIComponent(emailReceiver)}`;

      axios.patch(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          const modal = this.$refs.downloadDocsBurofaxModal;
          modal.successMessage = 'La solicitud se ha procesado exitosamente. Recibirá la documentación en el correo indicado.';
          modal.loading = false;
          setTimeout(() => {
            modal.closeModal();
          }, 5000);
        })
        .catch((error) => {
          const modal = this.$refs.downloadDocsBurofaxModal;
          let errorMsg = 'Ocurrió un error al procesar la solicitud. Por favor, inténtalo de nuevo.';

          if (error.response) {
            if (error.response.status === 400) {
              errorMsg = 'El archivo CSV tiene un formato inválido. Por favor, verifica el contenido.';
            } else if (error.response.status === 401 || error.response.status === 403) {
              errorMsg = 'No tienes permisos para realizar esta operación.';
            } else if (error.response.data && error.response.data.message) {
              errorMsg = error.response.data.message;
            }
          }

          modal.errorMessage = errorMsg;
          modal.loading = false;
          setTimeout(() => {
            modal.resetForm();
          }, 5000);
        });
    },

    handleUploadWalletCSV({ formData }) {
      const token = this.$cookies.get('token');
      const apiUrl = '/user/upload-csv/wallet';

      axios.patch(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          const modal = this.$refs.uploadWalletCSVModal;
          modal.successMessage = 'El archivo CSV se ha procesado exitosamente. Las transferencias han sido registradas.';
          modal.loading = false;
          setTimeout(() => {
            modal.closeModal();
          }, 5000);
        })
        .catch((error) => {
          const modal = this.$refs.uploadWalletCSVModal;
          let errorMsg = 'Ocurrió un error al procesar el archivo CSV. Por favor, inténtalo de nuevo.';

          if (error.response) {
            if (error.response.status === 400) {
              errorMsg = 'El archivo CSV tiene un formato inválido. Por favor, verifica el contenido.';
            } else if (error.response.status === 401 || error.response.status === 403) {
              errorMsg = 'No tienes permisos para realizar esta operación.';
            } else if (error.response.data && error.response.data.message) {
              errorMsg = error.response.data.message;
            }
          }

          modal.errorMessage = errorMsg;
          modal.loading = false;
          setTimeout(() => {
            modal.resetForm();
          }, 5000);
        });
    },

    handleUploadInvoiceCSV({ formData }) {
      const token = this.$cookies.get('token');
      const apiUrl = '/contract/upload-csv/invoice';

      axios.patch(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          const modal = this.$refs.uploadInvoiceCSVModal;
          modal.successMessage = 'El archivo CSV se ha procesado exitosamente. Las facturas serán reenviadas a los clientes.';
          modal.loading = false;
          setTimeout(() => {
            modal.closeModal();
          }, 5000);
        })
        .catch((error) => {
          const modal = this.$refs.uploadInvoiceCSVModal;
          let errorMsg = 'Ocurrió un error al procesar el archivo CSV. Por favor, inténtalo de nuevo.';

          if (error.response) {
            if (error.response.status === 400) {
              errorMsg = 'El archivo CSV tiene un formato inválido. Por favor, verifica el contenido.';
            } else if (error.response.status === 401 || error.response.status === 403) {
              errorMsg = 'No tienes permisos para realizar esta operación.';
            } else if (error.response.data && error.response.data.message) {
              errorMsg = error.response.data.message;
            }
          }

          modal.errorMessage = errorMsg;
          modal.loading = false;
          setTimeout(() => {
            modal.resetForm();
          }, 5000);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.operation-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.operation-icon {
  text-align: center;
  padding: 16px 0;
  color: #007bff;
}
</style>
